import { SubscriptionStatusEnum } from 'modules/payment/subscriptions/enums/subscription-status-enum'
import { SubscriptionStatusUiEnum } from '../enums/subscription-status-ui'
import { ManageSubscriptionsInterface } from '../types/manage-subscriptions-interface'

export const getSubscriptionStatus = (subscription: ManageSubscriptionsInterface) => {
  const subscriptionStatus = subscription.status
  const subscriptionItemStatus = subscription.subscriptionItems?.[0]?.status

  if (subscriptionStatus === SubscriptionStatusEnum.completed) {
    return SubscriptionStatusUiEnum.completed
  }

  if (
    subscriptionStatus === SubscriptionStatusEnum.active &&
    subscriptionItemStatus === SubscriptionStatusEnum.active
  ) {
    return SubscriptionStatusUiEnum.active
  }

  if (
    subscriptionStatus === SubscriptionStatusEnum.cancelled &&
    subscriptionItemStatus === SubscriptionStatusEnum.cancelled
  ) {
    return SubscriptionStatusUiEnum.cancelled
  }

  if (
    subscriptionStatus === SubscriptionStatusEnum.active &&
    subscriptionItemStatus === SubscriptionStatusEnum.cancelled
  ) {
    return SubscriptionStatusUiEnum.canceling
  }
}
